import React from 'react';
import * as Scrivito from 'scrivito';
import { pageLang, pick } from '../../lib/localize';

Scrivito.provideWidgetClass('ClientsCarouselWidget', {
  attributes: {
    images: 'linklist',
    title: 'string',
  },
});

const ClientsCarouselWidget = Scrivito.connect(({ widget }) => {
  const images = widget.get('images') || [];
  const title = widget.get('title');

  // Duplicate for seamless infinite loop
  const items = images.length > 0 ? [...images, ...images] : [];

  // The Rails template rendered nothing but the logos – no heading. The `title`
  // attribute exists (it holds the section name the anchor is built from) but was
  // never output, so showing it added an untranslated "Some or our clients" line.
  return (
    <section id="clients-carousel" className="tt-clients-carousel">
      {images.length > 0 ? (
        <div className="tt-clients-track-wrapper">
          <div id="clients-slider" className="tt-clients-track">
            {items.map((link, i) => {
              const obj = link.obj();
              // Rails served these through `transform(quality: 50)`. The JS SDK's
              // optimizeFor() only knows width/height, so the recompression is
              // gone – it changed file size, not layout.
              const imageUrl = obj ? obj.contentUrl() : link.url();
              const href = link.title();
              const img = (
                <img
                  src={imageUrl}
                  className="img-responsive"
                  alt={title || ''}
                  loading="lazy"
                />
              );
              return (
                <div key={i} className="item tt-clients-item">
                  {href ? <a href={href}>{img}</a> : img}
                </div>
              );
            })}
          </div>
        </div>
      ) : (
        <p className="text-center text-muted">{pick({ de: 'Noch keine Logos hinterlegt.', en: 'No images added yet.' }, pageLang())}</p>
      )}
    </section>
  );
});

Scrivito.provideComponent('ClientsCarouselWidget', ClientsCarouselWidget);

Scrivito.provideEditingConfig('ClientsCarouselWidget', {
  title: 'Client Logo Carousel',
  properties: ['title', 'images'],
  attributes: {
    title:  { title: 'Section Title' },
    images: { title: 'Client Logos', description: 'Add links to client logo images. Set the link title to the client\'s website URL.' },
  },
});

export default ClientsCarouselWidget;
